<script setup>
/**
 * FormControlProductTypesButtons
 * Headless structural modifier component.
 * Intercepts form schema parameters on mount, automatically hiding
 * its associated product type button elements from active view layouts.
 */
import { onMounted } from 'vue';

const props = defineProps({
    // Standard Orchestrator Props
    field: {
        type: Object,
        required: true
    },
    formId: {
        type: String,
        default: ''
    },
    currentData: {
        type: Object,
        default: () => ({})
    }
});

// --- Lifecycle ---

onMounted(() => {
    /**
     * Instantly enforce layout visibility hiding rules on mount
     * to protect configuration flow stability under Vite.
     */
    if (props.field) {
        props.field.hidden = true;
    }
});
</script>

<template>
</template>